/**
 * MIALIVIO NATURAL — Buybar wrapper + precio integrado en botón
 * Archivo: assets/custom-product-page.js
 *
 * Versión 4 — Label hardcodeado para evitar duplicación,
 * limpieza de restos antes de inyectar overlay.
 */
(function() {
  'use strict';

  // ============================================================
  // LABELS - Hardcodeados en español para evitar contaminación
  // ============================================================
  var LABELS = {
    add_to_cart: 'Agregar al carrito',
    sold_out: 'Agotado',
    unavailable: 'No disponible',
    preorder: 'Reservar'
  };

  function init() {
    var productInfos = document.querySelectorAll('product-info');
    if (!productInfos.length) return;

    productInfos.forEach(function(productInfo) {
      wrapBuybar(productInfo);
      initButtonPrice(productInfo);
      watchProductForm(productInfo);
    });
  }

  /**
   * Envuelve el quantity selector y el product-form en un wrapper común
   */
  function wrapBuybar(productInfo) {
    var quantityForm = productInfo.querySelector('[id^="Quantity-Form-"]');
    var productForm = productInfo.querySelector('product-form');

    if (!quantityForm || !productForm) return;
    if (quantityForm.closest('.mialivio-buybar')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'mialivio-buybar';
    wrapper.setAttribute('data-mialivio-buybar', '');

    quantityForm.parentNode.insertBefore(wrapper, quantityForm);
    wrapper.appendChild(quantityForm);
    wrapper.appendChild(productForm);
  }

  /**
   * Detecta el estado actual del botón para mostrar el label correcto
   */
  function detectButtonLabel(submitBtn) {
    var ariaDisabled = submitBtn.getAttribute('aria-disabled') === 'true';
    var hasDisabled = submitBtn.hasAttribute('disabled');
    var btnName = submitBtn.getAttribute('name');

    // Inspeccionar el texto crudo de Dawn (sin nuestro overlay)
    var clone = submitBtn.cloneNode(true);
    var existingOverlay = clone.querySelector('.mialivio-btn-overlay');
    if (existingOverlay) existingOverlay.remove();
    var dawnText = clone.textContent.trim().toLowerCase();

    // Detección por palabras clave en el texto de Dawn
    if (dawnText.indexOf('agotado') !== -1 || dawnText.indexOf('sold out') !== -1) {
      return LABELS.sold_out;
    }
    if (dawnText.indexOf('no disponible') !== -1 || dawnText.indexOf('unavailable') !== -1) {
      return LABELS.unavailable;
    }
    if (dawnText.indexOf('reservar') !== -1 || dawnText.indexOf('pre-order') !== -1 || dawnText.indexOf('preorder') !== -1) {
      return LABELS.preorder;
    }

    return LABELS.add_to_cart;
  }

  /**
   * Inyecta el overlay con label + precio dentro del botón.
   * También garantiza que .loading__spinner exista (Dawn lo necesita).
   */
  function initButtonPrice(productInfo) {
    var submitBtn = productInfo.querySelector('.product-form__submit');
    if (!submitBtn) return;

    // Limpiar overlays previos
    var existingOverlays = submitBtn.querySelectorAll('.mialivio-btn-overlay');
    existingOverlays.forEach(function(o) { o.remove(); });

    // GARANTIZAR QUE .loading__spinner EXISTA EN EL BOTÓN
    // Dawn 15.2 lo busca en onSubmitHandler. Si no existe, falla.
    var spinner = submitBtn.querySelector('.loading__spinner');
    if (!spinner) {
      spinner = document.createElement('div');
      spinner.className = 'loading__spinner hidden';
      spinner.innerHTML =
        '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
          '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
        '</svg>';
      submitBtn.appendChild(spinner);
    }

    // Detectar label según estado
    var label = detectButtonLabel(submitBtn);

    // Crear overlay
    var overlay = document.createElement('span');
    overlay.className = 'mialivio-btn-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<span class="mialivio-btn-text-label">' + escapeHtml(label) + '</span>' +
      '<span class="mialivio-btn-divider"></span>' +
      '<span class="mialivio-btn-price"></span>';

    submitBtn.appendChild(overlay);

    updateButtonPrice(productInfo);
    setupPriceObserver(productInfo);
  }

  /**
   * Observa cambios en el bloque de precio para mantener sincronizado
   */
  function setupPriceObserver(productInfo) {
    var sectionEl = productInfo.closest('.shopify-section') || productInfo;
    var priceContainer = sectionEl.querySelector('[id^="price-"]');

    if (!priceContainer || !window.MutationObserver) return;
    if (priceContainer.dataset.mialivioObserved === 'true') return;
    priceContainer.dataset.mialivioObserved = 'true';

    var observer = new MutationObserver(function() {
      updateButtonPrice(productInfo);
    });
    observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  /**
   * Observa el product-form. Si el botón es recreado por Dawn,
   * re-inyectamos el overlay limpio (sin duplicar).
   */
  function watchProductForm(productInfo) {
    var productForm = productInfo.querySelector('product-form');
    if (!productForm) return;
    if (productForm.dataset.mialivioWatched === 'true') return;
    productForm.dataset.mialivioWatched = 'true';

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function() {
      var submitBtn = productForm.querySelector('.product-form__submit');
      if (!submitBtn) return;

      // Caso A: el botón perdió todo el overlay (Dawn lo recreó)
      var hasOverlay = submitBtn.querySelector('.mialivio-btn-overlay');
      if (!hasOverlay) {
        initButtonPrice(productInfo);
        return;
      }

      // Caso B: hay overlay pero el label puede haber cambiado de estado (Agotado)
      var labelSpan = submitBtn.querySelector('.mialivio-btn-overlay .mialivio-btn-text-label');
      if (labelSpan) {
        var expectedLabel = detectButtonLabel(submitBtn);
        if (labelSpan.textContent !== expectedLabel) {
          labelSpan.textContent = expectedLabel;
        }
      }
    });

    observer.observe(productForm, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Actualiza solo el texto del precio dentro del overlay
   */
  function updateButtonPrice(productInfo) {
    var submitBtn = productInfo.querySelector('.product-form__submit');
    if (!submitBtn) return;

    var priceSpan = submitBtn.querySelector('.mialivio-btn-overlay .mialivio-btn-price');
    if (!priceSpan) return;

    var sectionEl = productInfo.closest('.shopify-section') || productInfo;
    var priceEl = sectionEl.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    var currentPrice = priceEl ? priceEl.textContent.trim() : '';

    priceSpan.textContent = currentPrice;

    var divider = submitBtn.querySelector('.mialivio-btn-overlay .mialivio-btn-divider');
    if (divider) {
      divider.style.display = currentPrice ? '' : 'none';
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();